import { takeLatest, put, all, call } from "redux-saga/effects";

import ProductActionTypes from "./product.types";
import {
  productDetailsAdd,
  productDetailsUpdate,
  productListGet,
  productDetailsFetch,
  productDetailsDelete,
  productQuestionDelete,
} from "./product.service";

import {
  addProductDetailsSuccess,
  addProductDetailsFailure,
  addProductDetailsResponseChanged,
  updateProductDetailsSuccess,
  updateProductDetailsFailure,
  updateProductDetailsResponseChanged,
  getProductListSuccess,
  getProductListFailure,
  getProductListResponseChanged,
  fetchProductDetailsSuccess,
  fetchProductDetailsFailure,
  fetchProductDetailsResponseChanged,
  deleteProductDetailsSuccess,
  deleteProductDetailsFailure,
  deleteProductDetailsResponseChanged,
  deleteProductQuestionSuccess,
  deleteProductQuestionFailure,
  deleteProductQuestionResponseChanged,
} from "./product.action";
import { encryptData } from "../../_common/enode-decode";

/** *********************  START GET PRODUCT LIST  ******************** */
export function* productDetailsListGet({ payload }: any) {
  try {
    const key = "GetAllProductPaginationKey";
    const { CompanyID, searchValueSet, limit, InstanceName } = payload;
    const jsonData = {
      CompanyID: CompanyID,
      InputSearch: searchValueSet,
      Limit: limit,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(productListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getProductListFailure(responseData.data));
    } else {
      yield put(getProductListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getProductListFailure(error));
  }
}

export function* resetGetProductListResponse() {
  yield put(getProductListResponseChanged());
}

export function* onGetProductListDetails() {
  yield takeLatest(
    ProductActionTypes.GET_PRODUCT_LIST_START,
    productDetailsListGet,
  );
}

export function* onGetProductListResponseReset() {
  yield takeLatest(
    ProductActionTypes.GET_PRODUCT_LIST_RESPONSE_RESET,
    resetGetProductListResponse,
  );
}
/** *********************  END GET PRODUCT LIST ******************** */

/** *********************  START ADD PRODUCT DETAILS  ******************** */
export function* createProduct({ payload }: any) {
  try {
    const key = "CreateProductKey";
    const {
      ProductName,
      ProductCode,
      CompanyID,
      UserName,
      UserID,
      PurposeOfFund,
      isAnnualTurnOver,
      isTermOfFundRequired,
      isOverdraftLimit,
      isPropertyType,
      isPropertyAddressLine1,
      isPropertyValue,
      isMonthlyCardTaking,
      isNoOfLocation,
      isRemainingValueOfmortgageOnProperty,
      InstanceName,
      isAmountRequested,
      isNoCardTerminals,
      isHowSoonFundNeeded,
      isPurposeOfFund,
      isMerchantProvider,
      isWhatIsThesettlementTime,
      isNoOfEpos,
      isAnnualCardTurnoverPerOutlet,
      isAvgTransactionValue,
      isPaymentsOverPhoneMOTO,
      isOnlinePayments,
      isEposName,
      isAmount,
      isBankingWindowClose,
      isNumberOfOutlets,
      isNumberOfCardMachines,
      isProductAddOn,
      isMultipleChoose,
      multipleChooseQuestionsJson,
    } = payload;

    const jsonData = {
      ProductName: ProductName,
      ProductCode: ProductCode,
      CompanyID: CompanyID,
      UserName: UserName,
      CreatedBy: UserID,
      PurposeOfFund: PurposeOfFund,
      InstanceName: InstanceName,
      IsAmountRequested: isAmountRequested,
      IsAnnualTurnOver: isAnnualTurnOver,
      IsTermOfFundRequired: isTermOfFundRequired,
      IsOverdraftLimit: isOverdraftLimit,
      IsPropertyType: isPropertyType,
      IsPropertyAddressLine1: isPropertyAddressLine1,
      IsPropertyValue: isPropertyValue,
      IsMonthlyCardTaking: isMonthlyCardTaking,
      IsNoOfLocation: isNoOfLocation,
      IsRemainingValueOfmortgageOnProperty:
        isRemainingValueOfmortgageOnProperty,
      IsNoCardTerminals: isNoCardTerminals,
      IsHowSoonFundNeeded: isHowSoonFundNeeded,
      IsMerchantProvider: isMerchantProvider,
      IsPurposeOfFund: isPurposeOfFund,
      IsWhatIsThesettlementTime: isWhatIsThesettlementTime,
      IsNoOfEpos: isNoOfEpos,
      IsAnnualCardTurnoverPerOutlet: isAnnualCardTurnoverPerOutlet,
      IsAvgTransactionValue: isAvgTransactionValue,
      IsPaymentsOverPhoneMOTO: isPaymentsOverPhoneMOTO,
      IsEposName: isEposName,
      IsAmount: isAmount ?? 0,
      IsOnlinePayments: isOnlinePayments,
      IsBankingWindowClose: isBankingWindowClose,
      IsNumberOfOutlets: isNumberOfOutlets,
      IsNumberOfCardMachines: isNumberOfCardMachines,
      IsProductAddOn: isProductAddOn ?? 0,
      IsMultipleChoose: isMultipleChoose ?? 0,
      MultipleChooseQuestions: multipleChooseQuestionsJson ?? "[]",
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(productDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addProductDetailsFailure(responseData.data));
    } else {
      yield put(addProductDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addProductDetailsFailure(error));
  }
}

export function* resetAddProductResponse() {
  yield put(addProductDetailsResponseChanged());
}

export function* onCreateProductDetails() {
  yield takeLatest(ProductActionTypes.ADD_PRODUCT_DETAILS_START, createProduct);
}

export function* onCreateProductResponseReset() {
  yield takeLatest(
    ProductActionTypes.ADD_PRODUCT_DETAILS_RESPONSE_RESET,
    resetAddProductResponse,
  );
}
/** *********************  END ADD PRODUCT DETAILS ******************** */

/** *********************  START UPDATE PRODUCT DETAILS  ******************** */
export function* productUpdate({ payload }: any) {
  try {
    const key = "UpdateProductKey";
    const {
      ProductName,
      ProductCode,
      CompanyID,
      UserName,
      UserID,
      OverdraftLimit,
      PropertyType,
      TermOfFundRequired,
      PurposeOfFund,
      PropertyAddress,
      AmountRequest,
      AnnualTurnOver,
      isAnnualTurnOver,
      isTermOfFundRequired,
      isOverdraftLimit,
      isPropertyType,
      isPropertyAddressLine1,
      isPropertyValue,
      isMonthlyCardTaking,
      isNoOfLocation,
      isRemainingValueOfmortgageOnProperty,
      InstanceName,
      isAmountRequested,
      isNoCardTerminals,
      ProductID,
      oldProductName,
      oldProductCode,
      isHowSoonFundNeeded,
      isMerchantProvider,
      isPurposeOfFund,
      isWhatIsThesettlementTime,
      isNoOfEpos,
      isAnnualCardTurnoverPerOutlet,
      isAvgTransactionValue,
      isPaymentsOverPhoneMOTO,
      isEposName,
      isAmount,
      isOnlinePayments,
      isBankingWindowClose,
      isNumberOfOutlets,
      isNumberOfCardMachines,
      isProductAddOn,
      isMultipleChoose,
      multipleChooseQuestionsJson,
    } = payload;

    const jsonData = {
      ProductID: ProductID,
      ProductName: ProductName,
      UpdatedBy: UserID,
      ProductCode: ProductCode,
      OldProductName: oldProductName,
      CompanyID: CompanyID,
      UserName: UserName,
      CreatedBy: UserID,
      AnnualTurnOver: AnnualTurnOver,
      AmountRequest: AmountRequest,
      PurposeOfFund: PurposeOfFund,
      TermOfFundRequired: TermOfFundRequired,
      OverdraftLimit: OverdraftLimit,
      PropertyType: PropertyType,
      PropertyAddress: PropertyAddress,
      InstanceName: InstanceName,
      IsAmountRequested: isAmountRequested,
      IsAnnualTurnOver: isAnnualTurnOver,
      IsTermOfFundRequired: isTermOfFundRequired,
      IsOverdraftLimit: isOverdraftLimit,
      IsPropertyType: isPropertyType,
      IsPropertyAddressLine1: isPropertyAddressLine1,
      IsPropertyValue: isPropertyValue,
      IsMonthlyCardTaking: isMonthlyCardTaking,
      IsNoOfLocation: isNoOfLocation,
      IsRemainingValueOfmortgageOnProperty:
        isRemainingValueOfmortgageOnProperty,
      IsNoCardTerminals: isNoCardTerminals,
      OldProductCode: oldProductCode,
      IsHowSoonFundNeeded: isHowSoonFundNeeded,
      IsMerchantProvider: isMerchantProvider,
      IsPurposeOfFund: isPurposeOfFund,
      IsWhatIsThesettlementTime: isWhatIsThesettlementTime,
      IsNoOfEpos: isNoOfEpos,
      IsAnnualCardTurnoverPerOutlet: isAnnualCardTurnoverPerOutlet,
      IsAvgTransactionValue: isAvgTransactionValue,
      IsPaymentsOverPhoneMOTO: isPaymentsOverPhoneMOTO,
      IsEposName: isEposName,
      IsAmount: isAmount ?? 0,
      IsOnlinePayments: isOnlinePayments,
      IsBankingWindowClose: isBankingWindowClose,
      IsNumberOfOutlets: isNumberOfOutlets,
      IsNumberOfCardMachines: isNumberOfCardMachines,
      IsProductAddOn: isProductAddOn ?? 0,
      IsMultipleChoose: isMultipleChoose ?? 0,
      MultipleChooseQuestions: multipleChooseQuestionsJson ?? "[]",
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(productDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateProductDetailsFailure(responseData.data));
    } else {
      yield put(updateProductDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateProductDetailsFailure(error));
  }
}

export function* resetUpdateProductDetailsResponse() {
  yield put(updateProductDetailsResponseChanged());
}

export function* onUpdateProductDetails() {
  yield takeLatest(
    ProductActionTypes.UPDATE_PRODUCT_DETAILS_START,
    productUpdate,
  );
}

export function* onUpdateProductResponseReset() {
  yield takeLatest(
    ProductActionTypes.UPDATE_PRODUCT_DETAILS_RESPONSE_RESET,
    resetUpdateProductDetailsResponse,
  );
}
/** *********************  END UPDATE PRODUCT DETAILS ******************** */

/** *********************  START DELETE PRODUCT DETAILS  ******************** */
export function* productDelete({ payload }: any) {
  try {
    const key = "DeleteProductKey";
    const {
      CompanyID,
      ProductID,
      ProductName,
      UserID,
      UserName,
      InstanceName,
    } = payload;
    const jsonData = {
      CompanyID: CompanyID,
      ProductID: ProductID,
      ProductName: ProductName,
      DeletedBy: UserID,
      UserName: UserName,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(productDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteProductDetailsFailure(responseData.data));
    } else {
      yield put(deleteProductDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteProductDetailsFailure(error));
  }
}

export function* resetDeleteProductDetailsResponse() {
  yield put(deleteProductDetailsResponseChanged());
}

export function* onDeleteProductDetail() {
  yield takeLatest(
    ProductActionTypes.DELETE_PRODUCT_DETAILS_START,
    productDelete,
  );
}

export function* onDeleteProductResponseReset() {
  yield takeLatest(
    ProductActionTypes.DELETE_PRODUCT_DETAILS_RESPONSE_RESET,
    resetDeleteProductDetailsResponse,
  );
}
/** *********************  END DELETE PRODUCT DETAILS ******************** */

/** *********************  START DELETE PRODUCT QUESTION (single row)  ******************** */
export function* deleteProductQuestion({ payload }: any) {
  try {
    const key = "DeleteProductQuestionKey";
    const {
      CompanyID,
      ProductID,
      QuestionID,
      UserID,
      UserName,
      InstanceName,
    } = payload;
    const jsonData = {
      CompanyID,
      ProductID,
      QuestionID,
      DeletedBy: UserID,
      UserName,
      InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(productQuestionDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteProductQuestionFailure(responseData.data));
    } else {
      yield put(deleteProductQuestionSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteProductQuestionFailure(error));
  }
}

export function* resetDeleteProductQuestionResponse() {
  yield put(deleteProductQuestionResponseChanged());
}

export function* onDeleteProductQuestion() {
  yield takeLatest(
    ProductActionTypes.DELETE_PRODUCT_QUESTION_START,
    deleteProductQuestion,
  );
}

export function* onDeleteProductQuestionResponseReset() {
  yield takeLatest(
    ProductActionTypes.DELETE_PRODUCT_QUESTION_RESPONSE_RESET,
    resetDeleteProductQuestionResponse,
  );
}
/** *********************  END DELETE PRODUCT QUESTION ******************** */

/** *********************  START FETCH PRODUCT DETAILS  ******************** */
export function* fetchProductData({ payload }: any) {
  try {
    const key = "FetchProductKey";
    const { CompanyID, ProductID, InstanceName } = payload;
    const jsonData = {
      CompanyID: CompanyID,
      ProductID: ProductID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(productDetailsFetch, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchProductDetailsFailure(responseData.data));
    } else {
      yield put(fetchProductDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchProductDetailsFailure(error));
  }
}

export function* resetFetchProductDetailsResponse() {
  yield put(fetchProductDetailsResponseChanged());
}

export function* onFetchProductDetails() {
  yield takeLatest(
    ProductActionTypes.FETCH_PRODUCT_DETAILS_START,
    fetchProductData,
  );
}

export function* onFetchProductResponseReset() {
  yield takeLatest(
    ProductActionTypes.FETCH_PRODUCT_DETAILS_RESPONSE_RESET,
    resetFetchProductDetailsResponse,
  );
}
/** *********************  END FETCH PRODUCT DETAILS ******************** */

export function* productMasterSaga() {
  yield all([
    call(onCreateProductDetails),
    call(onCreateProductResponseReset),
    call(onUpdateProductDetails),
    call(onUpdateProductResponseReset),
    call(onGetProductListDetails),
    call(onGetProductListResponseReset),
    call(onFetchProductDetails),
    call(onFetchProductResponseReset),
    call(onDeleteProductDetail),
    call(onDeleteProductResponseReset),
    call(onDeleteProductQuestion),
    call(onDeleteProductQuestionResponseReset),
  ]);
}
